const compareSchedules = (schedule1, schedule2) => {
	if (!schedule1 || !schedule2) return false;
	if (schedule1.length !== schedule2.length) return false;

	const sortedSchedule1 = [...schedule1].sort((a, b) => a.day - b.day);
	const sortedSchedule2 = [...schedule2].sort((a, b) => a.day - b.day);

	return sortedSchedule1.every((item1, index) => {
		const item2 = sortedSchedule2[index];
		return item1.day === item2.day && item1.open === item2.open && item1.close === item2.close;
	});
};

export { compareSchedules };
